<template>
    <div>
        <div v-if="loader" class="text-center">
            <loading-component></loading-component>
        </div>
        <div v-else class="container">
<!--            <el-alert-->
<!--                :title="'successfully booked.this is your ticket number  ' + book.ticket_number"-->
<!--                type="info">-->
<!--            </el-alert>-->
            <div class="card">
                <div class="card-header d-flex align-items-center">
                    Invoice
                    <strong>#90-98792</strong>
                    <div class="col text-right">
                        <a class="btn btn-sm btn-secondary mfs-auto mfe-1 d-print-none" href="#" onclick="javascript:window.print();">
                            Print
                        </a>
                    </div>
                </div>
                <div class="card-body">
                <div class="row mb-4">
                    <div class="col-sm-4">
                        <h6 class="mb-3">From:</h6>
                        <div>
                            <span style="font-weight: bold;font-size: 13px;">{{this.book.full_name}}</span>
                        </div>
<!--                        <div>{{this.book.city}} , {{this.book.country}}</div>-->
                        <div>Email: {{this.book.email}}</div>
                        <div>Phone: {{this.book.phone_number}}</div>
                    </div>

                    <div class="col-sm-4">
                        <h6 class="mb-3">To:</h6>
                        <div><strong style="font-size: 13px;">Ahsam Africa Hotel</strong></div>
                        <!--                        <div>{{this.book.city}} , {{this.book.country}}</div>-->
                        <div>Email: {{this.book.email}}</div>
                        <div>Phone: {{this.book.phone_number}}</div>
                    </div>
                    <div class="col-sm-4">
                        <h6 class="mb-3">Details:</h6>
                        <div>Booking Number: {{this. book.ticket_number}}</div>
                        <div>Checkin: {{this.book.checkin}}</div>
                        <div>Checkout: {{this.book.checkout}}</div>
                    </div>

                </div>
                <div class="table-responsive-sm">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th class="center">#</th>
                            <th>Room Type</th>
                            <th>Person</th>
                            <th class="center">No of Room(s)</th>
                            <th class="right">Unit Cost</th>
                            <th class="right">Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="center">1</td>
                            <td class="left">{{this.book.room_type.name}}, {{this.book.room_theme.name}}</td>
                            <td class="left">{{this.book.adult}} Adult,{{this.book.children}} Child,{{this.book.infant}} Infant, </td>
                            <td class="center">1</td>
                            <td class="right">${{this.book.payment}} </td>
                            <td class="right">${{this.book.payment}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-sd-9 ">
                        <p>Thank you for choosing Asham Africa Hotel & Resort.
                            We look forward to welcoming you and ensuring a most enjoyable stay. You will receive an email shortly confirming the details of your booking.
                            If there is anything we can do to make your stay extra special, please let us know by calling 212-929-1010 at extension 219.
                            We look forward to the pleasure of having you as our guest at Asham Africa Hotel & Resort.</p>
                    </div>
                    <div class="col-lg-4 col-sm-5 ml-auto">
                        <table class="table table-clear">
                            <tbody>
                            <tr>
                                <td class="left"><strong>Subtotal</strong></td>
                                <td class="right">${{this.book.payment}}</td>
                            </tr>
                            <tr>
                                <td class="left"><strong>Total</strong></td>
                                <td class="right"><strong>${{this.book.payment}}</strong></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="col text-right exit-button">
                            <a href="/">
                                <el-button>Exit</el-button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="footer" >
                <nav class="navbar navbar-expand-lg pt-0 pb-0" style="background-color: rgba(42, 43, 61, 0.9); border-bottom: solid; border-bottom-color: orange !important;">
                    <div class="container">
                        <br>
                        <a href="https://etmsoftwareplc.com/" class="navbar-brand text-white">
                            <span style="color: white !important; font-size: 11px">Powered By </span>
                            <img width="150px" height="40px" src="/img/frontend/brand/etm_logo_full.svg">
                        </a>
                        <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    import LoadingComponent from "../../common/LoadingComponent";
    export default {
        name: "ConfirmationComponent",
        props : {
          book:Object
        },
        components: {LoadingComponent},
        created() {
            console.log(this.book)
        },
        data() {
            return {
                loader:false
            }
        }
    }
</script>

<style scoped>
    @media print {
        .exit-button{
            display: none;
        }
        .footer{
            display: block;
        }
    }
</style>
